
import * as types from '../../action-types';
import AxiosCall from '../../../utils/axios';
import ErrorHandler from '../../../utils/error-handler';
export const myISOSingleRepaymentStart = () => ({
  type: types.GET_ISO_SINGLE_REPAYMENT_START
});

export const myISOSingleRepaymentSuccess = payload => ({
  type: types.GET_ISO_SINGLE_REPAYMENT_SUCCESS,
  payload
});

export const myISOSingleRepaymentFail = payload => ({
  type: types.GET_ISO_SINGLE_REPAYMENT_FAIL,
  payload
});

export const myISOSingleRepaymentCleanup = () => ({
  type: types.GET_ISO_SINGLE_REPAYMENT_CLEANUP
});

export const myISOSingleRepayment = (portal,type,id)=> async dispatch => {
  try {
    dispatch(myISOSingleRepaymentStart());
    const requestObj = {
      path: `repayment/${portal}/iso/${type}/${id}`,
      method: "GET",   
    }
    const  data  = await AxiosCall(requestObj);
    dispatch(myISOSingleRepaymentSuccess(data));
  } catch (err) {
    const error = ErrorHandler(err);
    dispatch(myISOSingleRepaymentFail(error));
  }
}